__turbopack_context__.v({
  "benefit": "uhx-module__az5faq__benefit",
  "description": "uhx-module__az5faq__description",
  "disclaimer": "uhx-module__az5faq__disclaimer",
  "uhxInfoDescription": "uhx-module__az5faq__uhxInfoDescription",
});
